import { TenantToSave } from 'src/services/api/tenant'
import { PartialTenant } from './initial-values'

export default function sanitizeToPost(values: PartialTenant) {
  const sanitized: TenantToSave = {
    tenant_setup: {
      tenant_organization_name: values.tenant_organization_name,
      tenant_sufix: values.tenant_sufix
    },
    organizations: []
  }

  if (typeof values.tenant_id !== 'string') {
    sanitized.tenant_setup.tenant_id = values.tenant_id
  }

  sanitized.organizations = values.organizations.reduce((acc, cur) => {
    if (typeof cur.organization_id !== 'string') {
      return acc
    }

    const email_contacts =
      cur.contacts.filter(c => c.contact_type === 'EMAIL')?.[0]
        ?.email_contacts?.[0]?.email ?? ''
    const phone_contact = cur.contacts.filter(
      c => c.contact_type === 'PHONE'
    )?.[0]?.phone_contacts?.[0].phone_number

    const { code, legal_name, trade_name, organization_type, vat_number } = cur
    const newOrganization: any = {
      code,
      email_contacts: [
        {
          description: '',
          email: email_contacts,
          main_email: false,
          verified: false
        }
      ],
      legal_name,
      organization_address: {
        address_number: cur.address.address_number,
        address: cur.address.address,
        city_id: +cur.address.city_id,
        country_id: +cur.address.country_id,
        description: '',
        state_id: +cur.address.state_id,
        zip_code: null as string
      },
      organization_type,
      phone_contact,
      trade_name,
      vat_number
    }

    return [...acc, newOrganization]
  }, [])

  return sanitized
}
